<section class="nhsuk-grid-row m-w-1200 mx-auto content-section">
  @if (isAlertVisible) {
    <div
      id="alert"
      role="alert"
      aria-live="assertive"
      tabindex="-1"
      class="floating-alert"
      [ngClass]="{
        'alert-success': alertType === 'success',
        'alert-danger': alertType === 'danger',
        'alert-info': alertType === 'info',
      }"
    >
      <span class="mb-0">{{ alertMessage }}</span>
      <button class="close-btn" aria-label="Dismiss alert" (click)="dismissAlert()">×</button>
    </div>
  }

  <h2 #pageTitle class="nhsuk-heading-xl mb-16" tabindex="-1">{{ isEditing ? 'Edit Version' : 'Create Version' }}</h2>
  <div class="nhsuk-back-link mb-16">
    <a class="nhsuk-back-link__link" routerLink="/admin/whats-new" tabindex="0">
      <svg
        class="nhsuk-icon nhsuk-icon__chevron-left"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        aria-hidden="true"
        height="24"
        width="24"
      >
        <path
          d="M8.5 12c0-.3.1-.5.3-.7l5-5c.4-.4 1-.4 1.4 0s.4 1 0 1.4L10.9 12l4.3 4.3c.4.4.4 1 0 1.4s-1 .4-1.4 0l-5-5c-.2-.2-.3-.4-.3-.7z"
        ></path>
      </svg>
      Back
    </a>
  </div>

  @if (!isLoading) {
    <form (ngSubmit)="onSubmit()" class="nhsuk-form-group" #whatsNewContentInstance="ngForm">
      <div class="flex gap-16">
        <div
          class="nhsuk-form-group nhsuk-grid-column-one-third p-i-0"
          [class.invalid]="!isVersionFormatValid && formSubmitted"
        >
          <label class="nhsuk-label" for="version">Version Number</label>
          <input
            class="nhsuk-input"
            id="version"
            name="version"
            type="text"
            placeholder="1.0.0"
            [(ngModel)]="whatsNewContent.version"
            (ngModelChange)="validateVersion()"
          />
          @if (!isVersionFormatValid && formSubmitted) {
            <span class="nhsuk-error-message mb-0">
              <span class="nhsuk-u-visually-hidden">Error:</span>
              The Version format should be x.x.x, example: 1.0.0
            </span>
          }
        </div>

        <div class="nhsuk-form-group nhsuk-grid-column-one-third p-i-0">
          <label class="nhsuk-label" for="status">Status</label>
          <select class="nhsuk-select" id="status" name="status" [(ngModel)]="whatsNewContent.status">
            <option value="draft">Draft</option>
            <option value="published">Published</option>
            <option value="archived">Archived</option>
            <option value="review">Review</option>
          </select>
        </div>
      </div>

      <div class="nhsuk-grid-row mb-24">
        <div class="nhsuk-form-group nhsuk-grid-column-full p-i-0">
          <label class="nhsuk-label" for="content">Content</label>
          <quill-editor id="content" name="content" format="json" [(ngModel)]="whatsNewContent.content"> </quill-editor>
        </div>
      </div>

      <div class="flex space-between">
        <div class="flex gap-16">
          <button [disabled]="isSaving" class="nhsuk-button" data-module="nhsuk-button" type="submit">
            @if (isSaving) {
              <app-loading-spinner />
            } @else {
              <span>Save</span>
            }
          </button>

          <button
            class="nhsuk-button nhsuk-button--secondary"
            data-module="nhsuk-button"
            type="button"
            (click)="onCancel()"
          >
            Cancel
          </button>
        </div>
        @if (isEditing) {
          <button
            class="nhsuk-button nhsuk-button--warning"
            data-module="nhsuk-button"
            type="button"
            (click)="onDelete()"
          >
            Delete
          </button>
        }
      </div>
    </form>

    @if (showConfirmDialog) {
      <app-confirmation-dialogue
        title="Delete Confirmation"
        message="Are you sure you want to delete this item? This action cannot be undone."
        (confirm)="onConfirmDelete()"
        (cancelEvent)="onCancelDelete()"
      />
    }

    <details class="nhsuk-details">
      <summary class="nhsuk-details__summary">
        <span class="nhsuk-details__summary-text"> Preview </span>
      </summary>
      <div class="nhsuk-details__text">
        <div class="nhsuk-grid-row">
          <div class="nhsuk-form-group nhsuk-grid-column-full p-i-0">
            <quill-view id="view" format="json" [content]="whatsNewContent.content"> </quill-view>
          </div>
        </div>
      </div>
    </details>
  }

  @if (isLoading) {
    <app-loading-spinner />
  }
</section>
